import { render, staticRenderFns } from "./PropertyEdit.vue?vue&type=template&id=de5173f2&scoped=true"
import script from "./PropertyEdit.vue?vue&type=script&lang=js"
export * from "./PropertyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5173f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de5173f2')) {
      api.createRecord('de5173f2', component.options)
    } else {
      api.reload('de5173f2', component.options)
    }
    module.hot.accept("./PropertyEdit.vue?vue&type=template&id=de5173f2&scoped=true", function () {
      api.rerender('de5173f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entrytypes/PropertyEdit.vue"
export default component.exports